import { AppBar, CssBaseline, Theme, Toolbar, Typography, WithStyles, withStyles } from "@material-ui/core";
import * as React from "react";
import { Route, Switch } from "react-router";
import "./App.css";
import Detail from "./Detail";
import Main from "./Main";
import Sidebar from "./Sidebar";

const styles = (theme: Theme) => ({
  root: {
    display: "flex",
    minHeight: "100%"
  },
  appBar: {
    width: `calc(100% - ${theme.drawerWidth}px)`,
    marginLeft: theme.drawerWidth
  },
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
    display: "flex",
    flexDirection: "column" as "column"
  },
  innerContent: {
    flexGrow: 1
  }
});

type Props = WithStyles<typeof styles>;

class MainApp extends React.Component<Props> {
  public render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar>
            {/*<IconButton
              color="inherit"
              aria-label="Open drawer"
              // onClick={this.handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>*/}
            <Typography variant="h6" color="inherit" noWrap>
              DATEV Analysis Tool
            </Typography>
          </Toolbar>
        </AppBar>
        <Sidebar />
        <main className={classes.content}>
          <div className={classes.toolbar} />

          <div className={classes.innerContent}>
            <Switch>
              <Route path="/detail/:accountNo" component={Detail} />
              <Route path="/" component={Main} />
            </Switch>
          </div>
        </main>
      </div>
    );
  }
}

export default withStyles(styles)(MainApp);



// WEBPACK FOOTER //
// ./src/MainApp.tsx